export default __webpack_public_path__ + "16e8f52082cd01fe8a0ab234c445076b.png";